import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=2710a270&scoped=true&"
import script from "./Certificate.vue?vue&type=script&lang=js&"
export * from "./Certificate.vue?vue&type=script&lang=js&"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=2710a270&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710a270",
  null
  
)

component.options.__file = "Certificate.vue"
export default component.exports